/* eslint-disable react/no-danger */
import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  iconMid: {
    padding: '5px',
    fontSize: 14
  },
  bigButton: {
    width: '100%',
    // padding: '0px 10px',
    borderRadius: 0,
    backgroundColor: 'white',
    height: 44,
    whiteSpace: 'pre-line',
    textAlign: 'left',
    padding: '0 5px',
    color: '#2196f3'
  },
  text: {
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '14px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  hightLight: {
    backgroundColor: '#6876E2',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#364090'
    }
  },
  iconHighLight: {
    '&:before': {
      color: '#ffffff'
    }
  },
  disableBtn: {
    backgroundColor: '#E0E0E0',
    color: 'rgba(0, 0, 0, 0.3)',

    '& div': {
      color: 'rgba(0, 0, 0, 0.3)'
    }
  },
  iconGochiKid: {
    backgroundImage: `url(/images/icon_gochi_kid.svg)`,
    backgroundSize: 'cover',
    width: 14,
    height: 14,
    margin: 5
  },
  iconGochiKidDisable: {
    backgroundImage: `url(/images/icon_gochi_kid_disable.svg)`
  }
};

const enhance = compose(pure);

const button = enhance(
  ({
    classes,
    classStyle,
    label,
    onClickAction,
    disableRegisStripe,
    stripeRegisteDone,
    disabled,
    disableGochiKid
  }) => {
    const iconHighLight = stripeRegisteDone && 'iconHighLight';
    const iconDisable =
      (disabled || disableRegisStripe || disableGochiKid) && 'iconDisable';
    const iconGochiKidDisable = disableGochiKid
      ? classes.iconGochiKidDisable
      : '';
    const icon = classStyle === 'iconGochiKid' ? classes.iconGochiKid : '';
    return (
      <Button
        className={[
          classes.bigButton,
          stripeRegisteDone && classes.hightLight,
          (disableRegisStripe || disableGochiKid) && classes.disableBtn
        ]}
        onClick={() => {
          onClickAction();
        }}
        disabled={disabled || disableRegisStripe || disableGochiKid}
      >
        <i
          className={`${icon} ${
            classes.iconMid
          } ${iconHighLight} ${iconDisable} ${iconGochiKidDisable}`}
        />
        <div
          className={classes.text}
          dangerouslySetInnerHTML={{ __html: label }}
        />
      </Button>
    );
  }
);

export default withStyles(styles)(button);
